<div #agentView class="card" [ngClass]="{'screenBlocked': agent.IsScreenBlocked == true, 
  'selectedAgent text-secondary': agent.isSelected == true, 
  'bg-white-80': agent.isSelected == false,
  'expanded-info': isSidebar === false && teamCheckInService.getIsTeamCheckInActive() === true,
  'rounded-pill': isSidebar === true || teamCheckInService.getIsTeamCheckInActive() === false}">
  <div class="col-12 px-2 py-1 d-flex flex-row">
    <div class="col-2 position-relative agent-img-container">
      <div *ngIf="agent.UploadLogStatus" class="spinner-border position-absolute z-index:20 m-2"></div>

      <img src={{loadedProfilePictureSource}} alt=""
        class="rounded-circle b-color agent-img-src {{isProfilePictureLoaded === false ? 'hidden' : ''}}"
        loading="lazy">

      <i class="fas fa-user agent-img-default {{isProfilePictureLoaded === true ? 'hidden' : ''}}"></i>

      <span
        class="aux-status {{agentConnectivityStatus.class}} agent-status-indicator border border-light rounded-circle"></span>
    </div>
    <div class="text-warning ps-2 me-1 pt-2 "
      [ngClass]="agent.ShowNotificationIcons || agent.ChatEnabled || agent.IsStealthModeRequested? 'col-4': 'col-8'">
      <h6 class="card-text text-truncate font-md m-0 font-primary-color fw-bolder text-left-align"
        data-bs-toggle="tooltip" data-bs-placement="top" title={{agent.FullName}}>
        {{agent.AgentFirstName + " " + agent.AgentLastName}}</h6>
      <p class="card-text text-truncate font-sm m-0 font-primary-color fw-bold lh-1 text-left-align mt-1"
        data-bs-toggle="tooltip" data-bs-placement="top" title={{agent.AgentTeamName}}>{{agent.AgentTeamName}}</p>

      <div class="d-flex pt-1">
        <div data-bs-toggle="tooltip" data-bs-placement="top" title={{agentConnectivityStatus.tooltip}}>
          <p class="card-text text-truncate font-sm m-0 font-primary-color f-w-50">{{agentConnectivityStatus.tooltip}}
          </p>
        </div>

        <p *ngIf="!archivedView" class="d-flex card-text m-0 " (click)=toggleAgentPin()>

          <i *ngIf="agent.IsPinned" class="fal fa-thumbtack pin" [ngClass]="agent.isSelected? 'text-white': ''"
            data-bs-toggle="tooltip" data-bs-placement="top" title="{{pinnedLabel}}"></i>

          <i *ngIf="!agent.IsPinned" class="fal fa-thumbtack unPin" [ngClass]="agent.isSelected? 'text-white': ''"
            data-bs-toggle="tooltip" data-bs-placement="top" title="{{pinLabel}}"></i>
        </p>

        <ul class="nav navbar-nav font-primary-color" (click)="settingsSelected(agent.LanID)">
          <li class="dropdown" (clickOutside)=unSetMenuAgentLanId()>
            <i class="fa-light fa-ellipsis-v archive font-primary-color" aria-hidden="true"
              [ngClass]="menuAgentLanId == agent.LanID? 'd-select': '' " data-bs-toggle="tooltip"
              data-bs-placement="top" title="{{optionsLabel}}"></i>
            <ul class="position-absolute dropdown-menu rounded-corner"
              [ngClass]="menuAgentLanId == agent.LanID? 'd-block': '' ">
              <div class="d-flex hover-lable" (click)="toggleAgentArchive()">
                <i class="fal fa-archive ms-3 me-1 mt-2 dropdowncolor font-md"></i>
                <li class="m-1 font-md" data-bs-placement="top">
                  {{agent.IsArchived? unarchiveLabel: archiveLabel}}</li>
              </div>

              <div (click)="logUpload()" class="d-flex hover-lable" data-bs-placement="top" [ngClass]="agent.LoginStatus == 'Logged Out'?'disabled': 
                  agent.UploadLogStatus ? 'disabled': ''">
                <i class="fal fa-arrow-up-from-bracket ms-3 me-1 mt-2 dropdowncolor font-md"></i>
                <li aria-disabled="true" class="m-1 font-md">
                  {{uploadLogsLabel}}
                </li>
              </div>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-5 ps-1 text-left-align"
      *ngIf="agent.ShowNotificationIcons || agent.ChatEnabled || agent.IsStealthModeRequested || webrtcInfoService.isAgentOnCall(agent.LanID)">
      <div>
        <section *ngIf="!archivedView">
          <ng-container *ngIf="agent.ShowNotificationIcons">
            <button *ngFor="let violation of agent.ViolationKeys" type="button"
              title={{appConfig.settings.ViolationNotificationTypes[violation].label}}
              class="text-primary-color action-icon btn bg-warm-color position-relative rounded-circle agent-list mb-1"
              [ngClass]="agent.isSelected? 'bg-primary-light': 'bg-primary-light'">

              <i class="fa-light" ngClass={{appConfig.settings.ViolationNotificationTypes[violation].icon_url}}></i>

              <span class="bg-warning position-absolute top-100 start-100 translate-middle badge rounded-pill">
                {{agent.Violations[violation]}}
                <span class="visually-hidden">unread messages</span>
              </span>
            </button>
          </ng-container>

          <button type="button" title="{{chatReceivedLabel}}" data-bs-toggle="tooltip" data-bs-placement="top"
            [ngClass]="agent.ChatEnabled && !archivedView? '' : 'd-none'"
            class="btn action-icon activecolor position-relative rounded-circle lh-1">
            <i class="fal fa-comment-dots text-white"></i>
          </button>

          <button type="button" title="{{stealthModeRequestedLabel}}" data-bs-toggle="tooltip" data-bs-placement="top"
            [ngClass]="agent.IsStealthModeRequested && !archivedView? '' : 'd-none'"
            class="btn action-icon bgred position-relative rounded-circle">
            <i class="fa-light fa-hood-cloak text-white"></i>
          </button>

          <div title="Screensharing In Progress" data-bs-toggle="tooltip" data-bs-placement="top"
            [ngClass]="webrtcInfoService.isAgentOnCall(agent.LanID) ? '' : 'd-none'"
            style="position: relative;width:22px;">
            <i class="fal fa-display"></i>
            <i class="fas fa-eye fa-stack-1x fa-inverse" style="transform: translate(-1px, 1px);font-size: 10px;"></i>
          </div>
        </section>
      </div>
    </div>

    <div class="col-1 align-self-center rounded-circle">
      <div *ngIf="agent.IsStealthModeActivated">
        <div>
          <i class="fa-duotone fa-hood-cloak text-black" title="{{stealthModeActivatedLabel}}" data-bs-toggle="tooltip"
            data-bs-placement="top"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="background-img-container"
    *ngIf="isSidebar === false && teamCheckInService.getIsTeamCheckInActive() === true">
    <img src="{{checkInInfo.ImageUrl}}" alt="Not Available"
      *ngIf="agentConnectivityStatus.status === 'LoggedIn' && checkInInfo.ImageUrl != null && checkInInfo.ImageUrl !== ''" />
    <div class="background-img-default-container"
      *ngIf="agentConnectivityStatus.status !== 'LoggedIn' || checkInInfo.ImageUrl == null || checkInInfo.ImageUrl === ''">
      <div class="background-img-default-inner-container">
        <span>{{getAgentInitials()}}</span>
      </div>
    </div>
    <div class="background-img-datetime"
      *ngIf="agentConnectivityStatus.status === 'LoggedIn' && checkInInfo.ImageUrl != null && checkInInfo.ImageUrl !== '' && checkInInfo.ImageCaptureDateTime != null">
      <span>{{checkInInfo.ImageCaptureDateTime | date : 'short'}}</span>
    </div>
  </div>
</div>